// Use https://www.color-blindness.com/color-name-hue to name the colour
export default {
  navy: '#0272f2', // used in focus outline
};
